import { render, staticRenderFns } from "./PurchaseExportDetails.vue?vue&type=template&id=45a76328&"
import script from "./PurchaseExportDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseExportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports